import { useActorMember, useAuthContext, useSubjectMember } from '@healthblocks-io/core'
import { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import { useAuthentication } from '@/modules/auth/hooks/useAuthentication'
import { AnimatedLoader } from '@/modules/shared/components/loader/Loader'
import { isHandlingUniversalLink } from '@/modules/shared/deep-links/UniversalLinkManager'
import { usePendingLink } from '@/modules/shared/deep-links/usePendingLink'
import { useLockoutTime } from '@/modules/shared/hooks/useLockoutTime'

const AuthRootPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const auth = useAuthContext()
  const actorMember = useActorMember()
  const subjectMember = useSubjectMember()
  const { lockout } = useLockoutTime()
  const { pendingLink } = usePendingLink()
  const { isProcessingCallback, isAuthenticated } = useAuthentication()

  const isAuthBootstrapping = auth.data.current === undefined

  // Robust check for code in URL
  const searchParameters = new URLSearchParams(location.search || window.location.search)
  const hasCodeInUrl = searchParameters.has('code')

  const shouldShowLoader =
    isAuthBootstrapping || isProcessingCallback || (hasCodeInUrl && !isAuthenticated) || (isAuthenticated && !lockout)

  useEffect(() => {
    if (!subjectMember || !actorMember || lockout || lockout === null) {
      return
    }

    if (isProcessingCallback) {
      return
    }

    if (!isHandlingUniversalLink.current && !pendingLink) {
      navigate('/home', { replace: true })
    }
  }, [
    actorMember?.id,
    subjectMember?.id,
    isAuthenticated,
    location,
    lockout,
    navigate,
    pendingLink,
    isProcessingCallback,
  ])

  if (shouldShowLoader) {
    return <AnimatedLoader cancellable />
  }

  return <Outlet />
}

export { AuthRootPage }
